import React from "react";
import { FormattedHTMLMessage, injectIntl } from "react-intl";
import { FormSelectChoice, InputSelectComponentProps } from "../../../lib/types/types";
import { FieldLabel } from "../../FieldLabel";
import { InputSelectComponent } from "../../FormInputs/InputSelect/InputSelectComponent";

export const StateSelect = ({
  value,
  isErrored,
  options,
  onChange,
  intl,
  placeholder = "",
  label = "",
  isRequired = false,
}: InputSelectComponentProps) => {
  const stateFieldId = "sid-state";

  return (
    <div className={`sid-field ${stateFieldId}__select`}>
      <div className="sid-l-space-top-md" />
      <FieldLabel
        text={label || <FormattedHTMLMessage id="state" defaultMessage="State where you live" />}
        htmlForLabel={stateFieldId}
        id={`${stateFieldId}-label`}
        displayClasses={placeholder && "sid-h-screen-reader-only"}
        isRequired={isRequired}
      />

      <InputSelectComponent
        fieldId="state"
        inputId={stateFieldId}
        fieldLabelId={`${stateFieldId}-label`}
        isErrored={isErrored}
        options={options}
        onChange={(state: FormSelectChoice) => onChange(state)}
        placeholder={intl.formatHTMLMessage({
          id: "statePlaceholder",
          defaultMessage: "State",
        })}
        value={options.find((option) => option.value === value)}
        suppressPlaceholder={false}
        isRequired={isRequired}
        buttonRef="inputSelectButtonState"
      />
      {isErrored ? (
        <div className="sid-field-error">
          <FormattedHTMLMessage id="errorId.invalidState" defaultMessage="Invalid state" />
        </div>
      ) : null}
    </div>
  );
};

export const StateSelectComponent = injectIntl(StateSelect);
